module.exports = __webpack_public_path__ + "img/pwa-ios-3.966e6d94.png";